import { render } from "./RecordedInference.vue?vue&type=template&id=28148be9&scoped=true"
import script from "./RecordedInference.vue?vue&type=script&lang=js"
export * from "./RecordedInference.vue?vue&type=script&lang=js"

import "./RecordedInference.vue?vue&type=style&index=0&id=28148be9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28148be9"]])

export default __exports__